<template>
  <div>
    <div v-if="form">
      <div v-if="!payload.is_create">
        <p class="bold">status</p>
        <select v-model="form.data.stat.fields.status.value">
          <option value="active">active</option>
          <option value="blocked">blocked</option>
          <option value="awaiting_manager">awaiting_manager</option>
          <option value="done">done</option>
        </select>
      </div>
      <div>
        <p class="bold">title</p>
        <input
          v-model="form.data.stat.fields.title.value"
          class="outlined"
          placeholder="title"
        />
      </div>
      <div :class="{ faded: payload.is_create }">
        <p class="bold">designator</p>
        <input
          v-model="form.data.stat.fields.designator.value"
          class="outlined"
          placeholder="designator"
        />
      </div>
      <div>
        <p class="bold">content</p>
        <textarea
          v-model="form.data.stat.fields.content.value"
          class="outlined"
          placeholder="content"
        />
      </div>
      <div>
        <p class="bold">priority</p>
        <input
          v-model="form.data.stat.fields.priority.value"
          class="outlined"
          placeholder="priority"
        />
      </div>
      <div>
        <p class="bold">owner</p>
        <input
          v-model="form.data.stat.fields.owner.value"
          class="outlined"
          placeholder="owner"
        />
      </div>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  props: ['payload'],
  name: 'admin-stats-form',
  data () {
    return {
      is_loading: false,
      form: undefined
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      if (this.payload.is_create) {
        this.setForm({
          id: ''
        })
        return
      }
      this.$network_utils.getStat(this.payload.data.id).then(response => {
        this.setForm(response)
      })
    },
    setForm (form_data) {
      this.form = new this.$form({
        stat: {
          fields: {
            status: {
              value: form_data.status,
              has_error: false,
              validations: []
            },
            title: {
              value: form_data.title,
              has_error: false,
              validations: []
            },
            designator: {
              value: this.payload.is_create ? 'manual' : form_data.designator,
              has_error: false,
              validations: []
            },
            content: {
              value: form_data.content,
              has_error: false,
              validations: []
            },
            priority: {
              value: form_data.priority,
              has_error: false,
              validations: []
            },
            owner: {
              value: form_data.owner,
              has_error: false,
              validations: []
            },
            created_by: {
              value: 'Admin',
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: this.payload.is_create ? 'post' : 'put',
            url: '/stats/' + form_data.id,
            headers: 'admin_headers'
          },
          is_used: true
        }
      })
    },
    submit () {
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      this.is_loading = true
      response.promise.then((response) => {
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'success' })
        this.remove(this.payload)
      })
    },
    ...mapMutations('modals', ['remove'])
  }
}
</script>
<style scoped>
  .remove_designator{
    pointer-events: none;
    opacity: 0.6;
  }
</style>
